// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusCircleFilledSvg from "@ant-design/icons-svg/es/asn/GooglePlusCircleFilled";
import AntdIcon from '../components/AntdIcon';

var GooglePlusCircleFilled = function GooglePlusCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusCircleFilledSvg
  }));
};

GooglePlusCircleFilled.displayName = 'GooglePlusCircleFilled';
export default React.forwardRef(GooglePlusCircleFilled);